import { useSyncExternalStore } from 'react';
import { getServerNowMs, subscribeServerClock } from '../services/serverClock';

/** 画面へ渡す時刻の刻み。残り時間は分単位で出すので、これより細かく描き直さない */
const SERVER_NOW_RESOLUTION_MS = 5 * 1000;

/**
 * 刻みにそろえたサーバー時刻を読む（刻みの間は同じ値を返し、描き直しを起こさない）
 * @returns {number | null} サーバー時刻（epoch ms）。分からない場合はnull
 */
const readServerNowMs = (): number | null => {
  /** 見積もったサーバー時刻 */
  const nowMs = getServerNowMs();
  return nowMs === null ? null : Math.floor(nowMs / SERVER_NOW_RESOLUTION_MS) * SERVER_NOW_RESOLUTION_MS;
};

/**
 * サーバー時刻を購読する
 * @returns {number | null} サーバー時刻（epoch ms）。取り直すまで分からない場合はnull
 */
const useServerNowMs = (): number | null => useSyncExternalStore(
  subscribeServerClock,
  readServerNowMs,
  readServerNowMs,
);

export default useServerNowMs;
